import React from 'react';
import { BRAND } from '@/utils/brand';
import { cn } from '@/lib/utils';

export const Logo = ({ size = 'md', showText = false, className }) => {
  const sizes = {
    xs: 'w-8 h-8',
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32',
    '2xl': 'w-48 h-48'
  };

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <img
        src={BRAND.logo}
        alt={BRAND.name}
        className={cn(sizes[size], 'object-contain rounded-lg')}
        data-testid="brand-logo"
      />
      {showText && (
        <div>
          <h1 className="text-xl font-bold text-blue-600 dark:text-blue-400">{BRAND.name}</h1>
          <p className="text-xs text-gray-500 dark:text-gray-400">{BRAND.tagline}</p>
        </div>
      )}
    </div>
  );
};
